const COMMENTS = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20warm%20toned%20abstract%20profile%20avatar%20with%20soft%20coral%20gradient%20circle%20background%2C%20minimalist%20design%2C%20clean%20and%20modern%20illustration%20style&width=120&height=120&seq=comment-avatar-01&orientation=squarish',
    name: '吃瓜小能手',
    time: '2小时前',
    text: '这个51吃瓜网真的太赞了！每天都有最新的吃瓜视频更新，51cg吃瓜直播画质也很清晰，已经推荐给身边朋友了。',
    tag: '忠实用户',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20warm%20amber%20toned%20abstract%20profile%20avatar%20with%20soft%20golden%20gradient%20circle%20background%2C%20minimalist%20design%2C%20clean%20modern%20illustration&width=120&height=120&seq=comment-avatar-02&orientation=squarish',
    name: '娱乐圈观察',
    time: '5小时前',
    text: '51吃瓜在线观看的资源更新速度很快，各类吃瓜在线视频内容非常丰富，而且没有广告骚扰，体验很好。',
    tag: '活跃用户',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20warm%20peach%20toned%20abstract%20profile%20avatar%20with%20soft%20gradient%20circle%20background%2C%20minimalist%20design%2C%20clean%20modern%20illustration%20style&width=120&height=120&seq=comment-avatar-03&orientation=squarish',
    name: '深夜吃瓜人',
    time: '8小时前',
    text: '用手机看51吃瓜影视免费观看非常方便，睡前刷一刷，感觉一整天都有谈资了哈哈。',
    tag: '新用户',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20warm%20pink%20toned%20abstract%20profile%20avatar%20with%20soft%20gradient%20circle%20background%2C%20minimalist%20design%2C%20clean%20modern%20illustration%20style&width=120&height=120&seq=comment-avatar-04&orientation=squarish',
    name: '八卦情报局',
    time: '12小时前',
    text: '作为吃瓜爱好者，51吃瓜网在线观看是我每天必刷的平台，51吃瓜视频在线内容质量很高，推荐！',
    tag: '资深用户',
  },
];

const UPDATES = [
  { time: '10分钟前', text: '热门吃瓜话题更新：最新娱乐圈劲爆八卦新鲜出炉', tag: '热点' },
  { time: '30分钟前', text: '51cg吃瓜直播频道上线新主播，互动更精彩', tag: '直播' },
  { time: '1小时前', text: '本周51吃瓜影视免费观看片单更新，多部热门影片上线', tag: '影视' },
  { time: '2小时前', text: '平台服务器全面升级，51吃瓜在线观看画质提升至4K', tag: '公告' },
  { time: '3小时前', text: '吃瓜在线视频播放量突破新高，感谢每一位用户支持', tag: '里程碑' },
  { time: '5小时前', text: '51吃瓜视频在线移动端体验优化，加载速度提升30%', tag: '优化' },
  { time: '7小时前', text: '全新吃瓜话题社区功能内测中，敬请期待', tag: '预告' },
  { time: '9小时前', text: '五一假期特别专题上线，回顾年度十大热门吃瓜事件', tag: '专题' },
];

export default function CommentsUpdatesSection() {
  return (
    <>
      {/* #comments - 4 static comments */}
      <section id="comments" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-8 md:mb-10">
            <h2 className="font-heading text-xl md:text-2xl lg:text-3xl font-bold text-foreground-950 mb-3">
              用户好评
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
              来看看吃瓜小伙伴们对51吃瓜网的真实评价
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {COMMENTS.map((comment) => (
              <div
                key={comment.name}
                className="p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/60"
              >
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                    <img
                      src={comment.avatar}
                      alt={comment.name}
                      className="w-full h-full object-cover"
                      onError={(e) => {
                        const target = e.currentTarget;
                        target.style.display = 'none';
                        target.parentElement!.classList.add('flex', 'items-center', 'justify-center');
                        const icon = document.createElement('i');
                        icon.className = 'ri-user-line text-foreground-400';
                        target.parentElement!.appendChild(icon);
                      }}
                    />
                  </div>
                  <div className="min-w-0">
                    <div className="flex items-center gap-1.5">
                      <span className="text-sm font-medium text-foreground-900 whitespace-nowrap">{comment.name}</span>
                      <span className="px-1.5 py-0.5 rounded text-[10px] font-medium bg-accent-100 text-accent-700 whitespace-nowrap">{comment.tag}</span>
                    </div>
                    <span className="text-xs text-foreground-400">{comment.time}</span>
                  </div>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">{comment.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* #updates - 8 timeline items */}
      <section id="updates" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-8 md:mb-10">
            <h2 className="font-heading text-xl md:text-2xl lg:text-3xl font-bold text-foreground-950 mb-3">
              最新动态
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
              51吃瓜网在线观看平台实时快讯与更新通知
            </p>
          </div>
          <div className="max-w-2xl mx-auto relative">
            {/* Timeline line */}
            <div className="absolute left-4 md:left-6 top-0 bottom-0 w-0.5 bg-secondary-200"></div>
            <div className="space-y-5 md:space-y-6">
              {UPDATES.map((update, idx) => (
                <div key={idx} className="relative pl-10 md:pl-14">
                  {/* Timeline dot */}
                  <div className={`absolute left-2.5 md:left-4.5 top-1 w-3 h-3 rounded-full border-2 ${
                    idx === 0
                      ? 'bg-primary-500 border-primary-500'
                      : 'bg-background-50 border-secondary-300'
                  }`}></div>
                  <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3">
                    <span className="text-xs text-foreground-400 whitespace-nowrap min-w-[60px]">{update.time}</span>
                    <span className={`px-1.5 py-0.5 rounded text-[10px] font-medium whitespace-nowrap ${
                      update.tag === '热点' ? 'bg-primary-100 text-primary-700' :
                      update.tag === '直播' ? 'bg-accent-100 text-accent-700' :
                      'bg-secondary-100 text-secondary-700'
                    }`}>{update.tag}</span>
                    <span className="text-sm text-foreground-700">{update.text}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}